import { render } from "./AsyncComponnets.vue?vue&type=template&id=895a4cfe"
import script from "./AsyncComponnets.vue?vue&type=script&lang=ts"
export * from "./AsyncComponnets.vue?vue&type=script&lang=ts"
script.render = render

export default script